import { dateToString } from "../../../features/data-types"
import { useServer } from "../../../services/server"
import { TableName } from "../../../tables"
import { SalePaymentItemData } from "../../sales"
import { useCheckActions } from "../actions/checkActions"
import { useCheckBuilders } from "../builders/checkBuilders"
import { useCashFundLoaders } from "../loaders/cashFundLoaders"
import { usePaymentTypeLoaders } from "../loaders/paymentTypeLoaders"

export const useAdministrationService = () => {
    const { buildCheck } = useCheckBuilders()

    const paymentTypeLoaders = usePaymentTypeLoaders()
    const cashFundLoaders = useCashFundLoaders()

    const { scheduleAccreditSalePayment, scheduleAccreditHoardPayment, scheduleAccreditCreditPayment, accreditSalePayment, accreditHoardPayment, accreditCreditPayment } = useServer()
    const { saveCheck } = useCheckActions()

    const accreditItemPayment = (
        table: TableName,
        operationId: string,
        paymentTypeId: string,
        destinationId: string,
        amount: number,
        paymentDate: Date = new Date()
    ) => {
        const isSale = table === TableName.SALE_ORDERS
        const isHoard = table === TableName.HOARD_ORDERS
        const accreditPayment = isSale ? accreditSalePayment : (isHoard ? accreditHoardPayment : accreditCreditPayment)
        return accreditPayment(operationId, paymentTypeId, destinationId, amount, dateToString(paymentDate))
    }

    const confirmItemPayment = async (
        table: TableName,
        operationId: string,
        paymentItem: Partial<SalePaymentItemData>,
        paymentDate: Date = new Date()
    ) => {
        const { paymentTypeId, cashFundId, amount } = paymentItem
        
        const { findPaymentType } = paymentTypeLoaders()
        const paymentType = findPaymentType(paymentTypeId)!
        
        if (paymentType.accreditationDays === 0) {
            await accreditItemPayment(table, operationId, paymentTypeId!, cashFundId!, amount!, paymentDate)
        } else if (paymentType.accreditationDays > 0) {
            const isSale = table === TableName.SALE_ORDERS
            const isHoard = table === TableName.HOARD_ORDERS
            const scheduleAccreditPayment = isSale ? scheduleAccreditSalePayment : (isHoard ? scheduleAccreditHoardPayment : scheduleAccreditCreditPayment)
            await scheduleAccreditPayment(operationId, paymentTypeId!, cashFundId!, amount!, dateToString(paymentDate))
        }

        const { loadAllCashFunds } = cashFundLoaders()
        await loadAllCashFunds()
    }

    const createItemCheck = (
        paymentItem: SalePaymentItemData,
        entryDate: Date = new Date()
    ) => {
        const { amount, checkType, checkName, checkIssueDate, checkPaymentDate, checkTaxId, checkEndorsable } = paymentItem
        const checkData = {
            type: checkType!,
            name: checkName!,
            amount,
            issueDate: checkIssueDate!,
            paymentDate: checkPaymentDate!,
            entryDate,
            taxId: checkTaxId!,
            endorsable: checkEndorsable!
        }
        const check = buildCheck(checkData)
        return saveCheck(check)
    }

    return {
        accreditItemPayment,
        confirmItemPayment,
        createItemCheck
    }
}
